export const VisualizacionSelect = ({ name, value, onChange }) => {
    return (
        <select name={name} value={value} onChange={onChange}>
            <option value='U'>Unidad</option>
            <option value='I'>Importe</option>
        </select>
    )
}